import { TaskInternalType } from '@gcv/shared';

export { getAssigneeName } from './get-assignee-name';
export { getGroupNames } from './get-group-names';
export { getGroupedAccountNames } from './get-grouped-account-names';
export type { GroupedAssigneeResult } from './get-grouped-assignee-name';
export { getGroupedAssigneeName } from './get-grouped-assignee-name';
export { getGroupedStatus } from './get-grouped-status';

export const COMMENT_TASK_TYPES: (TaskInternalType | undefined)[] = [
  TaskInternalType.COMMENTS,
  TaskInternalType.COMMENTS_REPLY,
  TaskInternalType.COMMENT_MENTION
];
